/**
 *  24/07/2019 v 1.0 - JuanMa
 *  v 1.7 31/10/2019 Añadida propiedad tabOrderManager
 *                   Añadida propiedad CampoNombre necesaria para la gestión de tabOrderManager
 *                   Cambiadas propiedades filtroNombreCampo y filtroTituloCampo por gridColumnaCampo y gridColumnaTitulo
 *  v 1.8 07/02/2020 Modificada la carga de elementos, tomandolos de response, en vez de response.lo
 *  v.1.9 24/03/2020 Modificado render para enviar al <SelectorLista>, la propiedad datoSelected= elementoSeleccionado.
 *                   Modificada la funcion asignarElementoSeleccionado para cuando no viene ningún elemento preseleccionado, marcar el primero.
 *                   Llamamos a objetoEsVacio en la funcion asignarElementoSeleccionado
 * v.1.10 28/05/2020 Añadido campoIdMostrar para añadir columna en el grid interno.
 *                   Añadido orden por defecto según el campoMostrar
 * v.1.11 28/07/2020 Añadida propiedad columnasAdicionales para añadir columnas a mostrar.
 * v.1.12 11/08/2020 Añadidas propiedades campoIdMostrar y campoIdTitulo
 * v.2.0 30/09/2020 Cambiado a framework2
 * v.2.1 04/10/2020 En ASignarElementoSeleccionado, comprobar que el elemento ha cambiado antes de hacer el setState para evitar Recursividad infinita.
 * v.2.2 05/10/2020 Modificado asignarElementoSeleccionado para usar filtrarConNombreCampoElemento
 *                  Añadida propiedad para indicar el tipo de grid.
 * v.2.3 09/10/2020 Corregido en Props: campoIdMostrar: PropTypes.string.   Estaba en bool.
 * v.2.4 12/11/2020 En método loadDeServidor : Limpiamos el campo noFiltrar de las condiciones del filtro.
 *                  Añadidas propiedades mostrarCodigoid y valorCodigoid para pasar a SelectorLista
 *
 * v.2.5 06/05/2022 Unión Sidemur y Planifikator
 * v.2.6 23/05/2022 En el render <SelectorLista, añadidos los parámetros:
 *                                      clickRowEsAceptar={true}
 *                                      tipoGrid= "reactdatagrid"
 *                  En onElementoChanged, eliminamos del elemento los campos acesorios que añade el grid, como por ejemplor rowIdx
 * v.2.7 24/05/2022 En loadDeServidor modificada la forma de obtener el filtro desde las condiciones.
 * v.2.8 30/05/2022 Añadida propiedad: onPropiedadesServicio
 *                  Creado loadDeServidorServicio
 *                  En load, añadid llamada a loadDeServidorServicio(); cuando se pasa onPropiedadesServicio
 *
 * v.2.9  05/06/2022 Unión planifikator y sidemur
 * v.2.10 16/06/2022 Añadidas propiedades onAccion y accionIcon
 *                   Modificado el render para mostrar el botón de acción.
 *
 * v.2.11 06/07/2022 Añadida en onElementoChanged, comprobacion de elemento antes de eliminar los campos superfluos.
 * v.2.12 07/07/2022 Añadido parametro valorObjetoInicial={valorInicial} en la llamada a <SelectorLista
 *
 * v.2.13 02/02/2023 Añadida propiedad readonly
 * v.2.14 04/10/2023 Modificado el tipo de la propiedad mostrarCodigoid: PropTypes.bool,
 *                   En render modificada la llamada a  <SelectorLista para añadir el paso de la propiedad width={width}
 * v.2.15 19/11/2023 Añadida propiedad classNameTitulo
 *                   Añadida propiedad renderConFormGroup
 * v.2.16 21/11/2023 Añadido método elementoEliminar
 *                   Modificado el export para poder utilizar ref y poder así llamar al método anterior desde el componente padre.
 * */

import React from 'react'
import "@blueprintjs/core/lib/css/blueprint.css";
import "@blueprintjs/table/lib/css/table.css";
import "@blueprintjs/icons/lib/css/blueprint-icons.css";
import PropTypes from 'prop-types';
import ClienteRestful from "../network/ClienteRestful";
import SelectorLista from "./SelectorLista";
import {filtrarConNombreCampo, filtrarConNombreCampoElemento} from "../utils/FilterUtils"
import {getFiltroFromCampo, getFiltroInicialFromCampoFECHAPERIODO, getFiltroFromCondicion} from "../utils/FiltroGridUtils";
import { FILTRO_MAYOR } from './FormularioGridBusqueda'
import {objetoEsVacio} from "../utils/ObjectUtils";
import {nombrePaquete} from "../../../dental/Configuracion";
import {cacheClaseChanged} from "../../../dental/redux/cache/actions";
import connect from "react-redux/es/connect/connect";


class SelectorListaClaseObjeto extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            titulo: props.titulo,
            campoValor: props.campoValor,
            campoMostrar: props.campoMostrar,
            campoIdMostrar: props.campoIdMostrar,
            campoIdTitulo: props.campoIdTitulo,
            valor: props.valor,
            valorInicial: props.valorInicial,
            elementos: [], //[{}],
            elementoSeleccionado: props.valor,
            cargandoDatos: false,
            noMostrarCero: props.noMostrarCero,
            claseSimple: this.calcularClaseSimple(props.clase),
            usarCache: props.usarCache ? props.usarCache : false,
        }

        this.refSelectorLista= React.createRef();
    }

    calcularClaseSimple= (clase) => {
        //console.log(" XXXXXXXXXXXXXXXXXXXXXX calcularClaseSimple");
        //console.log("clase: ", clase);
        //console.log("nombrePaquete: ", nombrePaquete);
        let pos= nombrePaquete.length;
        let claseSimple= clase.substr(pos);
        return claseSimple;
    }

    componentDidUpdate(prevProps, prevState) {
        this.asignarElementoSeleccionado();
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState) {
        const newState = {};

        if (nextProps.valor !== prevState.valor) {
            newState.valor = nextProps.valor;
        }
        if (nextProps.valorInicial !== prevState.valorInicial) {
            newState.valorInicial = nextProps.valorInicial;
            newState.elementoSeleccionado = nextProps.valorInicial;
        }

        if (nextProps.camposValor !== prevState.camposValor) {
            newState.camposValor = nextProps.camposValor;
        }
        if (nextProps.campoMostrar !== prevState.campoMostrar) {
            newState.campoMostrar = nextProps.campoMostrar;
        }
        if (nextProps.usarCache !== prevState.usarCache) {
            newState.usarCache = nextProps.usarCache;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }

    load= () => {
        const {usarCache} = this.state;
        const {onPropiedadesServicio} = this.props;

        if (usarCache) {
            //Comprobamos si está cacheado:
            const {claseSimple} = this.state;
            const {cache} = this.props;
            let datosCacheados = cache.clases[claseSimple];
            if (datosCacheados) {
                this.setState({cargandoDatos: false, elementos: datosCacheados}, () => {
                    this.asignarElementoSeleccionado();
                });
            } else {
                this.loadDeServidor();
            }
        }
        else{
            if (!onPropiedadesServicio)
                this.loadDeServidor();
            else
                this.loadDeServidorServicio();
        }
    }

    loadDeServidor = () => {
        const {claseSimple, noMostrarCero} = this.state;
        const {urlServicioRestful, condiciones, campoMostrar} = this.props;
        const url= urlServicioRestful + "list/" + claseSimple;
        const clienteRestful = new ClienteRestful().setUrl(url);

        //console.log("SELECTORLISTACLASEOBJETO - LoadDeServidor");
        //console.log("claseSimple: ", claseSimple);
        //console.log("url:", url);

        var filtro= {condiciones: [], orden: []};
        condiciones && condiciones.forEach ( (condicion) => {
            filtro.condiciones.push(getFiltroFromCondicion(condicion));
        });
        /*
        condiciones && condiciones.forEach ( (campo) => {
            if (campo.valor)  {
                let filtroCampo = getFiltroFromCampo(campo, campo.valor, campo.valor2);
                if (filtroCampo)
                    filtro.condiciones.push(filtroCampo);
            }
            if (campo.tipoValor){
                let filtroCampo=  getFiltroInicialFromCampoFECHAPERIODO(campo);
                if (filtroCampo)
                    filtro.condiciones.push(filtroCampo);
            }
        });
         */
        filtro.orden.push({nombreCampo: campoMostrar, asc: true});

        //Limpiamos el campo noFiltrar de las condiciones del filtro, para evitar un error ya que ese campo no existe en la clase JAVA:
        filtro.condiciones.forEach( (condicion) => {
            delete (condicion.noFiltrar);
        })

        //Añadimos condicion de cero inmutable
        //console.log(noMostrarCero);
        if (noMostrarCero){
            //console.log("NON CERO")
            filtro.condiciones.push(
                {nombreCampo: "codigo", tipo: FILTRO_MAYOR,  valor: 0}
            );
        }

        console.log("filtro: ");
        console.log(filtro);

        clienteRestful.doPost( filtro, response => {
            if (clienteRestful.exito && response){
                //console.log(response);
                let newElementos= response;
                //let newElementos= response.lo;
                //console.log(newElementos);

                this.setState({cargandoDatos: false, elementos: newElementos}, () => {
                    this.asignarElementoSeleccionado();
                    this.props.dispatch(cacheClaseChanged(claseSimple, newElementos));
                });

            }
        });
    }

    loadDeServidorServicio = () => {
        const {urlServicioRestful, onPropiedadesServicio} = this.props;
        const url= urlServicioRestful;
        const clienteRestful = new ClienteRestful().setUrl(url);

        console.log("SELECTORLISTACLASEOBJETO - LoadDeServidorServicio");
        console.log(url);

        let propiedadesServicio= onPropiedadesServicio && onPropiedadesServicio();

        console.log("propiedades: ", propiedadesServicio);

        clienteRestful.doPost( propiedadesServicio, response => {
            if (clienteRestful.exito && response){
                console.log(response);
                let newElementos= response;

                this.setState({cargandoDatos: false, elementos: newElementos}, () => {
                    this.asignarElementoSeleccionado();
                });

            }
        });

    }


    onLoadDatoSelected= (valor, callback) => {

    }

    asignarElementoSeleccionado= () => {
        const {valor, elementos, campoValor, elementoSeleccionado} = this.state;
        const {clase} = this.props;

        //console.log("ASIGNAR ELEMENTO SELECCIONADO");

        if (elementos && elementos.length > 0){
            if(campoValor && !objetoEsVacio(campoValor)) {
                let newElementoSeleccionado= filtrarConNombreCampoElemento(elementos, campoValor, valor);
                if (newElementoSeleccionado != elementoSeleccionado)
                    this.setState({elementoSeleccionado: newElementoSeleccionado});
                //console.log("newElementoSeleccionado", newElementoSeleccionado);
            }
            //#Nuevo
            else{
                this.setState({elementoSeleccionado: elementos[0]});
                //console.log("elementos[0]", elementos[0]);
            }
        }

    }

    onElementoChanged= (elemento) => {
        const {onElementoChanged} = this.props;
        //console.log(" XXXXX SelectorListaClaseObjeto: onElementoChanged");
        //console.log(elemento);

        //Limpiamos el elemento de campos accesorios que ha incluido el grid:
        //HAcemos la comprobación, porque cuando se elimina, elemento entrsa como null y da un error si eliminamos sus campos.
        if (elemento) {
            delete elemento.rowIdx;
            delete elemento.filaSeleccionada;
        }

        this.setState({elementoSeleccionado: elemento}, () => {
            onElementoChanged && onElementoChanged(elemento);
        })
    }

    onListaMostrar= () => {
        const {elementos} = this.state;
        if (!elementos || elementos.length === 0){
            this.setState({cargandoDatos: true}, () => {this.load()})
        }
    }

    elementoEliminar= () => {
        console.log("SelectorlistaclaseObjeto  ELEMENTOELIMINAR <-------------");
        if (this.refSelectorLista && this.refSelectorLista.current)
            this.refSelectorLista.current.onEliminar();
    }

    render() {
        const {titulo, icon, elementos, elementoSeleccionado, campoMostrar, campoIdMostrar, campoIdTitulo, valorInicial, cargandoDatos} =  this.state;
        const {tabOrderManager, campoNombre, obligatorio, columnasAdicionales, tipoGrid, mostrarCodigoid,
        onAccion, accionIcon, onAbrirFormularioElemento, readonly, onMostrarTexto, width, classNameTitulo, renderConFormGroup} = this.props;


        //console.log("++++ SelectorListaClaseObjeto: Render +++++ ", titulo);
        //console.log("renderConFormGroup: ", renderConFormGroup);

        //console.log("onAbrirFormularioElemento: ", onAbrirFormularioElemento);
        /*
        console.log("elementoSeleccionado:");
        console.log(elementoSeleccionado);
        */

        //tabOrderManager.log();

        let valorMostrar= "";
        let valorCodigoid= "";
        if (elementoSeleccionado) {
            valorMostrar = elementoSeleccionado[campoMostrar];
            valorCodigoid=  elementoSeleccionado.codigoid;
        }
        else {
            if (valorInicial) {
                valorMostrar = valorInicial[campoMostrar];
                valorCodigoid = valorInicial.codigoid;
            }
        }
        /*
        console.log(">>>> ElementoSeleccionado: ", elementoSeleccionado);
        console.log(">>>> ValorCodigoid: ", valorCodigoid);
        console.log(">>>> mostrarCodigoid: ", mostrarCodigoid);
        */
        //console.log("!!!!!!!!!!", titulo);
        return (
            <SelectorLista id= {titulo} width={width}
                           datos={elementos}
                           valor={valorMostrar}
                           titulo={titulo}
                           icon={icon}
                           gridColumnaCampo={campoMostrar} gridColumnaTitulo={titulo}
                           gridColumnaIdCampo={campoIdMostrar} gridColumnaIdTitulo={campoIdTitulo}
                           OnDatoChanged={ this.onElementoChanged}
                           onMostrar={this.onListaMostrar}
                           cargandoDatos={cargandoDatos}
                           tabOrderManager={tabOrderManager}
                           campoNombre={campoNombre}
                           obligatorio={obligatorio}
                           //datoSelected={elementoSeleccionado} //#Nuevo
                           columnasAdicionales={columnasAdicionales}
                           tipoGrid={tipoGrid}
                           mostrarCodigoid= {mostrarCodigoid}
                           valorCodigoid={valorCodigoid}
                           renderConFormGroup={true}

                           clickRowEsAceptar={true}
                           tipoGrid= "reactdatagrid"

                           onAccion={onAccion}
                           accionIcon={accionIcon}
                           onAbrirFormularioElemento={onAbrirFormularioElemento}

                           valorObjetoInicial={valorInicial}
                           readonly={readonly}
                           onMostrarTexto={onMostrarTexto}

                           classNameTitulo={classNameTitulo}
                           renderConFormGroup= {renderConFormGroup}

                           ref={this.refSelectorLista}
            />
        );
    }
}


SelectorListaClaseObjeto.propTypes = {
    clase: PropTypes.string.isRequired,
    titulo: PropTypes.string.isRequired,
    campoValor: PropTypes.string.isRequired,
    campoMostrar: PropTypes.string.isRequired,
    valor: PropTypes.object,
    valorInicial: PropTypes.object,
    icon: PropTypes.string,
    urlServicioRestful: PropTypes.string.isRequired,
    condiciones: PropTypes.array,
    obligatorio: PropTypes.bool,
    columnasAdicionales: PropTypes.array,
    campoIdMostrar: PropTypes.string,
    campoIdTitulo: PropTypes.string,
    usarCache: PropTypes.bool,
    tipoGrid: PropTypes.string,
    mostrarCodigoid: PropTypes.bool,
    onPropiedadesServicio: PropTypes.func,
    readonly: PropTypes.bool,
    onAccion: PropTypes.func,
    accionIcon: PropTypes.string,
    onMostrarTexto: PropTypes.func,
    renderConFormGroup: PropTypes.bool,
    classNameTitulo: PropTypes.string,
}

const mapStateToProps = function(state) {
    return {
        cache: state.cache,
    }
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(SelectorListaClaseObjeto);

